import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import BedVisualizer from './components/BedVisualizer'
import BedList from './components/BedList'
import { useAppStore } from './stores/appStore'
import './index.css'
import './i18n'

// Create a client
const queryClient = new QueryClient()

function AppContent() {
  const { initializeFromURL } = useAppStore()
  
  useEffect(() => {
    initializeFromURL()
  }, [initializeFromURL])
  
  // Simple routing based on pathname
  const pathname = window.location.pathname
  
  if (pathname === '/bed-list') {
    return <BedList />
  }
  
  return <BedVisualizer />
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppContent />
    </QueryClientProvider>
  )
}
